<template>
   <section class="contact p-number">
    
         <div class="container">
            <div class="row">
               <div class="col-sm-12 col-md-4" v-for="(item, index) in data.items" :key="index">
                  <div
                     class="services-items mb-3 mb-md-0"
                     data-aos="flip-left"
                     data-aos-easing="ease-out-cubic"
                     data-aos-duration="800"
                  >
                     <h5>{{ item.title }}</h5>
                     <span>{{ item.caption }}</span>
                     <ul>
                        <li v-for="(link, linkIndex) in item.links" :key="linkIndex">
                           <i v-bind:class="link.icon"></i>
                           <span>{{ link.title }}</span>
                        </li>
                     </ul>
                     <ul>
                        <li v-for="(list,index) in item.List" :key="index">{{list.title}}</li>
                     </ul>
                  </div>
               </div>
            </div>
         </div>
   </section>
</template>
<script>
export default {
   props: {
      data: {
         type: Object,
      },
   },
};
</script>
<style scoped>
.contact {
   width: 100%;
   min-height: 350px;
   text-align: center;
   background-color: #f8f8f8;
   padding: 50px 0;
   margin: 10px 0;
}

.services-items {
   width: 100%;
   height: 350px;
   border-radius: 10px;
   text-align: justify;
   overflow: hidden;
   border: 1px solid white;
   background-color: white;
   padding: 12px;
   transition: all 0.5s;
}

.services-items:hover {
   border: 1px solid #ebc75d;
   transform: scale(1.01);
}

.services-items ul {
   list-style-type: none;
   padding: 0;
}

.services-items ul li {
   padding: 0;
   text-align: right;
   display: inline-block;
   margin: 5px;
}

.services-items i {
   margin-left: 10px;
   font-size: 20px;
   color: #ebc75d;
}

.services-items h5 {
   text-align: center;
   padding-top: 20px;
   padding-bottom: 20px;
}

.services-items span {
   padding-top: 30px;
}
</style>
